<template>
  <el-scrollbar>
    <div class="scrollbar-flex-content">
      <CTable>
        <CTableHead>
          <tr  class="d-flex" :class="`from${info.part_item_id}`">
            <CTableHeaderCell :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'">
              <CButton
                class="btn-outline-primary text-light"
                v-if="!showChild"
                @click="showChild = !showChild"
              >
                <img src="@/assets/icons/arrow-blue.svg" alt="" />
              </CButton>
              <CButton
                class="btn-outline-primary text-light"
                v-else
                @click="showChild = !showChild"
              >
                <img
                  class="openImg"
                  src="@/assets/icons/arrow-blue.svg"
                  alt=""
                />
              </CButton>
            </CTableHeaderCell>
            <CTableHeaderCell
              :class="showChild ? '' : 'd-none'"
              v-for="option in info.extension_info.cols"
              :key="option.title"
              :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'"
            >
              {{ option.title }}
            </CTableHeaderCell>
          </tr>
        </CTableHead>
        <CTableBody :class="showChild ? 'd-block' : 'd-none'">
          <tr
            v-for="option in info.extension_info.rows"
            :key="option.title"
            :class="`from${info.part_item_id}`"
            class="d-flex"
          >
            <CTableHeaderCell :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'">
              {{ option.title }}
            </CTableHeaderCell>
            <CTableDataCell
              class=""
              :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'"
              v-for="option in info.extension_info.cols"
              :key="option.title"
            >
              <CFormTextarea
                v-if="option.type === $defines.Part_Item_From_Type_Text"
                placeholder="請填入文字"
                rows="3"
                style="resize: none"
              />
              <CFormInput
                v-if="option.type === $defines.Part_Item_Date_Date_Number"
                placeholder="請填入數字"
                @change="ChangeNumber"
                oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
              />
              <CFormCheck
                v-if="
                  option.type === $defines.Part_Item_From_Type_True_Or_False
                "
                required
              />
            </CTableDataCell>
          </tr>
        </CTableBody>
      </CTable>
    </div>
  </el-scrollbar>
</template>

<script>
import { ref } from '@vue/runtime-core'
 
export default {
  props: {
    options: {
      type: Object,
      default: () => {},
    },
    id: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const showChild = ref(true)
    // onMounted(()=>{
    //   const tr = document.querySelectorAll(`.from${props.info.part_item_id}`)
    //       if(tr){
    //         const trWidth = props.info.extension_info.cols.length * 250 + 'px';
    //         tr.forEach(e=>{
    //           e.style.width = trWidth
    //         })
    //       }
    // })
    const ChangeNumber = ($event) => {
      if ($event?.targ$eventt?.value) {
        $event.target.value = `${Number($event.target.value)}`
      }
    };
    return{
      ChangeNumber,
      showChild
    }
  },
}
</script>
<style lang="scss" scoped>
.openImg {
  rotate: (180deg);
}
.scrollbar-flex-content {
  display: flex;
}
.scrollbar-demo-item {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 50px;
  margin: 10px;
  text-align: center;
  border-radius: 4px;
  background: var(--el-color-danger-light-9);
  color: var(--el-color-danger);
}
</style>
